import AudienceInterests from "./AudienceInterests.vue";

export default AudienceInterests;
